import axios from 'axios';
import {backendHost} from '../../config';

export const getPromoByPartnerId = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/promo/partner`, {params});
};